export default __webpack_public_path__ + "static/media/Pfizer-Logo.3ecfb005.png";